import axios from "axios";
import { useMutation } from "@tanstack/react-query";
import { API_BASE_PATH, API_BASE_RELATIVE_PATH } from "../Config/Config";

const bulkEditFlow = async ({ testCaseId, data, flow }) => {
  const userDetailString = localStorage.getItem("userDetail");
  if (!userDetailString) throw new Error("No user details found in localStorage");

  const user = JSON.parse(userDetailString);

  const response = await axios.post(
    `${API_BASE_PATH}${API_BASE_RELATIVE_PATH}?action=updateBulkFlows&Flow=${flow}&companyid=${user.companyid}&testCaseId=${testCaseId}`,
    data,
  );

  return response.data;
};

const useBulkEditFlow = () => {
  return useMutation({
    mutationFn: (variables) => bulkEditFlow(variables),
  });
};

export default useBulkEditFlow;
